import { useSelector } from 'react-redux';
import { getMarketplaceProductsSelector, getMarketplaceProductSummary } from '../../marketplace/marketplace-selectors';
import { URLUtils } from '@vm/omega-shared-component-webapp';
import { formatPayload } from '../../../utils/format-payload';
import { ProductSummaryType } from '../../../types/types';

export const getProductSummary = (): ProductSummaryType => {
  const { payload } = URLUtils.parsePayloadFromURL();
  const { productId, nbaId } = formatPayload(payload);
  const { data: productData, ready: productListReady, error: productListError } = useSelector(getMarketplaceProductSummary(productId));

  // used to determine if the product details call has worked and track it
  const { ready: productDataReady, error: productDataError } = useSelector(getMarketplaceProductsSelector);

  return {
    productSummary: {
      ...productData,
      productId,
      nbaId,
    },
    productListReady,
    productListError,
    productDataReady,
    productDataError,
  };
};
